/* eslint-disable no-unused-vars */
import { useState } from "react";
import InventoryAdjustmentList from "./inventory-adjustment/InventoryAdjustmentList";
import PurchaseList from "../unifiedPurchase/PurchaseList";

import PurchaseOrderList from "./purchase-request/PurchaseOrderList";
import PurchaseReturnList from "./purchase-request/PurchaseReturnList";

import PurchaseOrderDashBoard from "./PurchaseOrderDashBoard";
import InventoryAdjustmentDraftList from "./inventory-adjustment/InventoryAdjustmentDraftList";
import InventoryAdjustmentHistoryList from "./inventory-adjustment/InventoryAdjustmentHistoryList";
import StockTransferList from "./stockTransfer/StockTransferList";
import ProductionList from "./production/ProductionList";
import MPurchaseCrud from "../unifiedPurchase/MPurchaseCrud";

export default function PurchaseOrderHome(props) {
  const [activeView, setActiveView] = useState("DASH_BOARD");

  props.biRef.purchaseOrderHome = {
    parentEvent: parentEvent,
  };

  function parentEvent(eventType) {
    if (eventType == "returnHome") {
      changeView("DASH_BOARD");
    }
  }

  function changeView(viewType) {
    console.log("viewType", viewType);
    if (viewType == "PO_LIST") {
      setActiveView("PO_LIST");
    } else if (viewType == "PO_LIST_N") {
      setActiveView("PO_LIST_N");
    } else if (viewType == "DASH_BOARD") {
      setActiveView("DASH_BOARD");
    } else if (viewType == "IA_LIST") {
      setActiveView("IA_LIST");
    } else if (viewType == "PR_LIST") {
      setActiveView("PR_LIST");
    } else if (viewType == "PR_LIST_N") {
      setActiveView("PR_LIST_N");
    } else if (viewType == "IV_DRAFT_LIST") {
      setActiveView("IV_DRAFT_LIST");
    } else if (viewType == "IV_HISTORY") {
      setActiveView("IV_HISTORY");
    } else if (viewType == "OUT_LIST") {
      setActiveView("OUT_LIST");
    } else if (viewType == "IN_LIST") {
      setActiveView("IN_LIST");
    } else if (viewType == "ProductionList") {
      setActiveView("ProductionList");
    } else if (viewType == "GRN_NEW") {
      setActiveView("GRN_NEW");
    } else if (viewType == "LPO_CREATE") {
      setActiveView("LPO_CREATE");
    } else if (viewType == "GRV_NEW") {
      setActiveView("GRV_NEW");
    }
  }
  function showDashBoard() {
    setActiveView("DASH_BOARD");
  }
  return (
    <div>
      {activeView === "DASH_BOARD" && (
        <PurchaseOrderDashBoard
          changeView={changeView}
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          productCache={props.productSearchCache}
        ></PurchaseOrderDashBoard>
      )}
      {activeView === "PO_LIST" && (
        <PurchaseOrderList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          changeView={changeView}
          productCache={props.productSearchCache}
        ></PurchaseOrderList>
      )}
      {activeView === "PO_LIST_N" && (
        <PurchaseList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          changeView={changeView}
          productCache={props.productSearchCache}
          returnFlag={false}
        ></PurchaseList>
      )}
      {activeView === "IA_LIST" && (
        <InventoryAdjustmentList
          changeView={changeView}
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          productCache={props.productCache}
        ></InventoryAdjustmentList>
      )}
      {activeView === "PR_LIST" && (
        <PurchaseReturnList
          changeView={changeView}
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          productCache={props.productSearchCache}
        ></PurchaseReturnList>
      )}
      {activeView === "PR_LIST_N" && (
        <PurchaseList
          changeView={changeView}
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          productCache={props.productSearchCache}
          returnFlag={true}
        ></PurchaseList>
      )}
      {activeView === "IV_DRAFT_LIST" && (
        <InventoryAdjustmentDraftList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          changeView={changeView}
          productCache={props.productSearchCache}
        ></InventoryAdjustmentDraftList>
      )}
      {activeView === "IV_HISTORY" && (
        <InventoryAdjustmentHistoryList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          changeView={changeView}
          productCache={props.productSearchCache}
        ></InventoryAdjustmentHistoryList>
      )}
      {activeView === "OUT_LIST" && (
        <StockTransferList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          changeView={changeView}
          productCache={props.productSearchCache}
          stockTransferType={"OUT"}
        ></StockTransferList>
      )}
      {activeView === "IN_LIST" && (
        <StockTransferList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          changeView={changeView}
          productCache={props.productSearchCache}
          stockTransferType={"IN"}
        ></StockTransferList>
      )}
      {activeView === "ProductionList" && (
        <ProductionList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          changeView={changeView}
          productCache={props.productSearchCache}
        ></ProductionList>
      )}{" "}
      {activeView === "GRN_NEW" && (
        <MPurchaseCrud
          //setCurrentPage={setCurrentScreen}
          setCurrentScreen={showDashBoard}
          //currentScreen={currentScreen}
          poType={"GRN"}
          title={"Goods receive note"}
          mode="create"
          returnFlag={false}
          //onRefresh={onRefresh}
          //proceedForSettlement={proceedForSettlement}
          //data={purchaseItems}
          //updatePurchaseItemData={setPurchaseItems}
          //handleOrderSettlement={handleOrderSettlement}
          /*taxType={taxType}*/
          context={props.context}
          showMessage={props.showMessage}
          productCache={props.productSearchCache}
        ></MPurchaseCrud>
      )}
      {activeView === "GRV_NEW" && (
        <MPurchaseCrud
          //setCurrentPage={setCurrentScreen}
          setCurrentScreen={showDashBoard}
          //currentScreen={currentScreen}
          poType={"GRV"}
          title={"Goods return voucher"}
          mode="create"
          returnFlag={true}
          //onRefresh={onRefresh}
          //proceedForSettlement={proceedForSettlement}
          //data={purchaseItems}
          //updatePurchaseItemData={setPurchaseItems}
          //handleOrderSettlement={handleOrderSettlement}
          /*taxType={taxType}*/
          context={props.context}
          showMessage={props.showMessage}
          productCache={props.productSearchCache}
        ></MPurchaseCrud>
      )}
      {activeView === "LPO_CREATE" && (
        <MPurchaseCrud
          setCurrentScreen={showDashBoard}
          poType={"LPO"}
          title={"Local purchase order"}
          mode="create"
          returnFlag={false}
          //onRefresh={onRefresh}
          //proceedForSettlement={proceedForSettlement}
          //data={purchaseItems}
          //updatePurchaseItemData={setPurchaseItems}
          //handleOrderSettlement={handleOrderSettlement}
          /*taxType={taxType}*/
          context={props.context}
          showMessage={props.showMessage}
          productCache={props.productSearchCache}
        ></MPurchaseCrud>
      )}
    </div>
  );
}
